import { RedirectMechanismType, TrackingQueryStringKey, TravelCurrencyCode } from '@graphql/generated';

export enum PartnerHotelIdType {
  hotels = 'hotels',
  joy = 'joy',
  stays = 'stays',
}

export enum PartnerSourceIdType {
  hotels = 'zh',
  joy = 'joyPlace',
  stays = 'nuitee',
}

export enum PartnerHotelDetailsRouteQueryParams {
  discountCode = 'discountCode',
  eventId = 'eventId',
  idType = 'idType',
  joyPlaceId = 'joyPlaceId',
  source = 'source',
  utm_campaign = 'utm_campaign',
  utm_medium = 'utm_medium',
  utm_source = 'utm_source',
  utm_source_secondary = 'utm_source_secondary',
}

export interface RedirectMechanismProps
  extends Readonly<{
    __typename?: 'RedirectMechanism';
    telemetryDestinationName: string;
    trackingQueryStringKey?: TrackingQueryStringKey | null;
    type: RedirectMechanismType;
    url: string;
  }> {}

export interface GoogleMapsProps
  extends Readonly<{
    lat?: number | null;
    lng?: number | null;
    gplid?: string | null;
    name?: string | null;
    address?: string | null;
    zentrumHubId?: string | null;
  }> {}

export interface Pricing
  extends Readonly<{
    digits: number;
    valueInMinorUnits: number;
    currency: TravelCurrencyCode;
    floatingPointDecimalString: string;
  }> {}

export interface PricingInfoProps
  extends Readonly<{
    nightlyBaseRate: Pricing;
    strikeoutNightlyBaseRate?: Pricing | null;
  }> {}

export interface TravelPlaceProps
  extends Readonly<{
    id?: string | null;
    url?: string | null;
    name?: string | null;
    customUrl?: string | null;
    type: 'joyPlace' | 'accommodationPlace';
  }> {}

export interface TelemetryHotelInfo
  extends Readonly<{
    hotelName?: string | null;
    hotelPrice?: string | null;
    hotelStrikeOutPrice?: string | null;
    hotelPriceCurrency?: TravelCurrencyCode | null;
  }> {}

export interface GuestPartnerHotelBookingRedirectParams
  extends TelemetryHotelInfo,
    Readonly<{
      telemetryName?: string;
      hotelSearchPageUrlType?: 'hotelSoldOut' | 'hotelWebsite'; // Currently support only hotelSoldOut interceptor, we will support different types.
      redirectMechanismType?: RedirectMechanismType;
      clientReference?: string;
      destinationName?: string;
      destinationUrl?: URL;
      zentrumHub?: {
        readonly id: string;
      };
      hotelWebsite?: {
        readonly value: string;
      };
      googleMaps?: {
        readonly gplid?: string;
        readonly name?: string;
        readonly address?: string;
        readonly lat?: string;
        readonly lng?: string;
      };
      source?: string | null;
      utm_source?: string | null;
      utm_source_secondary?: string | null;
      utm_medium?: string | null;
      utm_campaign?: string | null;
      redirectToSafeLink?: boolean;
      onTelemetrySend?: () => void;

      // For Joy room blocks
      roomBlockUrl?: URL;
      roomBlockSuccess?: boolean;
    }> {}
